function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M16.293 5.437a.496.496 0 00-.451.137l-2.046 2.044a1 1 0 11-1.413-1.416l2.049-2.047a.499.499 0 00-.163-.816A4.397 4.397 0 008.42 8.838c.03.09.007.19-.06.258l-4.832 4.827a1.802 1.802 0 002.55 2.55l4.829-4.828a.247.247 0 01.257-.06 4.4 4.4 0 005.498-5.847.512.512 0 00-.369-.3z",
  fill: "#545454",
  fillRule: "evenodd"
})));